import React, { useState, useEffect } from "react";
import { TextField, Autocomplete, FormControl, Popper } from "@mui/material";

const RegistrationSelect = React.forwardRef(
  ({ hasError, options, label, errorMessage, onChange, name, triggerValidation, isEdit=false, ...props }, ref) => {

    // Find the selected option by comparing the value
    const selectedOption = name === "areaCode" ?
     options?.find(option => option?.value === props?.value?.value && option?.key === props?.value?.key) : 
     options?.find(option => option?.value === props?.value) || null;

    const [error, setError] = useState(false || hasError);

    // console.log(props, label)

    useEffect(() => {
      setError(errorMessage !== undefined);
    }, [errorMessage]);

    const getTextWidth = (text, font = "14px Inter") => {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      context.font = font;
      return context.measureText(text).width;
    };

    const CustomPopper = (props) => {
      const longestLabel = props.modifiersData?.options?.reduce((a, b) =>
        (a?.label?.length || 0) > (b?.label?.length || 0) ? a : b
      );
      
      const labels = props?.options || [];
      const longestWidth = Math.max(
        ...labels.map((opt) => getTextWidth(opt.label || ""))
      );
    
      const dynamicWidth = Math.min(longestWidth + 60, window.innerWidth - 100); // Add padding, max limit
    
      return (
        <Popper
          {...props}
          style={{ width: `${dynamicWidth}px`, zIndex: 1300 }}
          placement="bottom-start"
        />
      );
    };
    

    return (
      <FormControl
        sx={{
          borderRadius: "4px",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          margin: "auto",
          marginBottom: "7px",
        }}
        error={errorMessage}
      >
        <Autocomplete
          options={options}
          getOptionLabel={(option) => option.label || ""}
          getOptionDisabled={(option) => option.value==="na"}
          required={props.required}
          style={{ width: "100%", paddingRight: "0px", paddingLeft: "0px" }}
          value={selectedOption}
          PopperComponent={(props) => (
            <CustomPopper {...props} options={options} />
          )}          
          isOptionEqualToValue={(option, value) => 
            name === "areaCode" ? option.key === value?.key : option.value === value.value && option.key === value?.key // Compare both value and key
          }          
          onChange={(event, newValue) => {
            onChange({
              target: { name, value: newValue ? name === "areaCode" ? newValue : newValue.value : "", key: newValue ? newValue.key : "", label: newValue?.label ?? '' },
            });
            if (triggerValidation) {
              triggerValidation(name);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              required={props.required}
              ref={ref}
              sx={{
                width: "100%",
                borderRadius: "4px",
                fontFamily: "Inter",
                fontSize: "10px",
                background: "white",
                marginBottom: "4px",
                '& .MuiInputBase-root': {
                  maxHeight: "40px",
                  // padding: "6px 10px",
                  paddingRight: "32px !important",
                  fontSize: "12px", // Reduced font size of input text
                },
                // "& .MuiOutlinedInput-notchedOutline": {
                //   borderColor:  (props.required && (props.value === "" || props.value === "null") && isEdit) || hasError ? "red" : "inherit",
                // },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor:
                    (props.buttonPressed &&
                    props.required &&
                    (!props.value || props.value === "" || props.value === "null" || props.value === "na"))
                      ? "red"
                      : "inherit",
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "12px",
                  textAlign: "center",
                },
              }}
            />
          )}
          disabled={props.disabled}
          sx={{
            width: "100%",
            borderRadius: "4px",
            fontFamily: "Inter",
            fontSize: "12px",
            background: "white",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: error || hasError ? "red" : "inherit",
            },
            "& .MuiInputBase-input": {
              textOverflow: "unset !important",
              overflow: "visible !important",
              whiteSpace: "normal !important",
            },
          }}
          fullWidth
        />
      </FormControl>
    );
  }
);

export default RegistrationSelect;
